import { EPages } from '@microfrontends/app-shell-v2'
import { ELanguage } from '@microfrontends/react-components'
import FixedBottomButton from '../../components/Numerology/FixedBottomButton'
import MainLayout from '../../containers/MainLayout'
import NumerologyContainer from '../../containers/NumerologyContainerV2'
import { withTranslation } from '../../i18n'
import { ETypeNumerologyPage } from '../../services/models'
import { INumerologyPageProps, getServerSideProps } from '../../ssr/numerology'

export function Numerology(props: INumerologyPageProps) {
	const { isRobot = false, articles, famousPeople } = props
	const today = new Date()

	return (
		<MainLayout
			{...props}
			metaCanonical='nhan-so-hoc'
			numerologyPage={ETypeNumerologyPage.HomeNumerology}
			languageCode={ELanguage.VI}
			pageName={EPages.NUMEROLOGY}
			metaTitle={`Tra cứu nhân số học, thần số học Online miễn phí ${today.getFullYear()} | VietnamWorks`}
			metaDescription='Nhân số học là một bộ môn khoa học giúp nghiên cứu ý nghĩa các con số để từ đó chỉ ra những điểm mạnh, điểm yếu, tính cách và tâm hồn của con người. Kiểm tra ngày sinh, tháng sinh và công việc phù hợp. Cùng VietnamWorks giải mã các con số thông qua công cụ tra cứu thần số học Online nhanh nhất.'
			responsiveCornerColor='#005AFF'
			externalResponsiveElement={<FixedBottomButton />}
		>
			<NumerologyContainer
				isRobot={isRobot}
				articles={articles}
				famousPeople={famousPeople}
			/>
		</MainLayout>
	)
}
export default withTranslation('home')(Numerology as any)
export { getServerSideProps }
